import { useState, useRef, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function Login(props) {
    const [user, setUser] = useState("")
    const [password, setPassword] = useState("")  
    const [message, setMessage] = useState("")  

   
    const userRef = useRef(null);

  useEffect(() => {
    props.newToken("");
    props.newUsrGrupo(0);
    props.newUsrId(0);
    props.newUsrName("");
 
  }
    , [user, props.show])

   useEffect(() => {
      if (useRef.current) {
      useRef.current.focus();
    }
  }, [])  

  const handleCancelar = () =>
  {
    setUser("");
    setPassword("");
  }
 async function handleLogin(e){
      e.preventDefault()
      try {
         
          var options = {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            mode: 'cors',
            credential : 'include',
           //credential : 'same-origin',
            //body : {},
            //body: {"user":"mark", "password" : "mar1"},
            body: JSON.stringify({"usuario" : user, "clave" : password}),
            };
        
          fetch(`${process.env.REACT_APP_API_URL}/usr/valid`, options)
          .then( response => response.json())
          .then( data => {
             
             if(data.user)
             {
              console.log("token ", data.user.token);
              props.newToken(data.user.token);
              props.newUsrId(data.user.Usr_IdUsr);
              props.newUsrGrupo(data.user.Gus_IdGus);
              props.newGrupo(data.user.Gru_IdGru);
              props.newUsrName(data.user.Usr_ApeyNom);
             
              props.onHide(); 
             }
             else
             {
              setMessage(data.message);
             }
            
            
          })
         // navigate('/')
      } catch (error) {
          console.log(error);
          
      }
  }




  async function handleKeyDown(e){
   
 if (e.key === 'Enter') {
       handleLogin(e);
     }
  else
    { 
      setMessage("");

    }

  }  

return (
    <Modal
      show={props.show} // Usa la prop que viene de App.js
      onHide={props.onHide}
      backdrop="static"
      keyboard={false}
      size="md"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Ingreso al sistema</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="form-group">
          <label>Usuario</label>
          <input
            type="email"
            className="form-control"
            onKeyDown={handleKeyDown}
            onChange={(e) => setUser(e.target.value)}
            placeholder="Ingrese su usuario"
            ref={userRef}
          />
        </div>
        <div className="form-group">
          <label>Clave</label>
          <input
            type="password"
            className="form-control"
            onKeyDown={handleKeyDown}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Clave"
          />
        </div>
        {message && <p className="text-danger mt-2">{message}</p>}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancelar}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleLogin}>
          Ingresar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Login;
